import {pushAnalyticsData} from "../../utils";

( function( $ ) {
	'use strict';

	$( document ).ready( function() {

		let $addToCartContainers = $( '.add-to-cart-container' );

		if ( ! $addToCartContainers.length ) {
			return;
		}

		let isPartnershipIdCookieUpdated = false;

		const settings = {
			apiPrefix: $addToCartContainers.first().data( 'studentapi' ),
			subsidiaryId: $addToCartContainers.first().data( 'subsidiary' ),
			ajax: {
				async: true,
				crossDomain: true,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				processData: false,
			}
		};

		const user = {
			studentId: '',
			cartId: '',
			role: '',
			isLoggedIn: false,
		};

		/**
		 * these modes are mutually exclusive, i.e. the control can be in only one mode at a time
		 */
		const Mode = {
			unchecked: 'unchecked',
			sellable_prompt: 'sellable_prompt',
			sellable_done: 'sellable_done',
			enrollable_prompt: 'enrollable_prompt',
			enrollable_done: 'enrollable_done',
			waitable_disabled: 'waitable_disabled',
			waitable_prompt: 'waitable_prompt',
			unavailable: 'unavailable',
		}

		let isStateSelected = true;

		const enrollment_requested = [];
		const add_to_cart_requested = [];

		const containers = {};

		//$( document ).ready( init );
		init();
		$( window ).on( 'popstate', init );

		$(window).on( 'ColibriEvent:INIT_ADD_TO_CART', ( event, newContainer ) => {
			if ( event.originalEvent instanceof CustomEvent ) {
				newContainer = event.originalEvent.detail ?? null;
			}
			init( null, newContainer ? $(newContainer): newContainer );
		} );

		$(window).on( 'ColibriEvent:UNINDEX_ADD_TO_CART', ( event, container ) => {
			/**
			 * this event is to be triggered before an Add To Cart button gets destroyed
			 * (or its product code attribute gets changed)
			 */
			if ( event.originalEvent instanceof CustomEvent ) {
				container = event.originalEvent.detail ?? null;
			}

			/**
			 * If a button has two product codes, make sure to deindex both
			 */
			if ( typeof container.data('product-code') !== 'undefined' ) {
				const productCodes = [ container.data('product-code') ];

				if ( typeof container.data( 'alt-product-code' ) !== 'undefined' ) {
					productCodes.push( container.data('alt-product-code') );
				}

				$(productCodes).each( ( i, productCode ) => {
					/**
					 * Update the `containers` index
					 */
					let pos = - 1;

					if ( typeof containers[ productCode ] === 'undefined' ) {
						console.log('containers[ productCode ] is undefined ');
						return;
					}

					$( containers[ productCode ].elements ).each( ( i, el2 ) => {
						if ( container[ 0 ] === el2[ 0 ] ) {
							pos = i;
							return false; //found, break out of each()
						}
					} );

					if ( pos !== - 1 ) {
						/**
						 * The current button was found, remove it from the elements array
						 */
						containers[ productCode ].elements.splice( pos, 1 );
					}

					if ( containers[ productCode ].elements && containers[ productCode ].elements.length === 0 ) {
						/**
						 * there are no more elements left, remove product code from the index
						 */
						delete containers[ productCode ];
					}

					/**
					 * Update the `$addToCartContainers` index
					 */
					$addToCartContainers = $addToCartContainers.not( $( container ) );
				});
			}
		} );

		$(window).on( 'ColibriEvent:INIT_ALL_ADD_TO_CARTS', ( event, $wrapper ) => {
			const $containers = $wrapper.find('.add-to-cart-container');
			if ( !$containers.length ) {
				return;
			}
			let $last;
			$containers.each( ( i, candidate ) => {
				let pos = - 1;
				$addToCartContainers.each( ( i, el ) => {
					if ( candidate === el ) {
						pos = i;
						return false;
					}
				} );
				if ( pos === - 1 ) {
					$last = $(candidate);
					$.merge( $addToCartContainers, $last );
				}
			} );
			if ( $last !== undefined ) {
				// avoid infinite loops when this even is triggered in AFTER_STATUS_CHECK
				init();
			}
		} );

		function init( __, $newContainer = null ) {
			if ( $newContainer && $newContainer.length ) {
				/**
				 * if we got a reference to a new container, add it to the global selection
				 */
				let pos = - 1;

				$addToCartContainers.each( ( i, el ) => {
					if ( $newContainer[0] === el ) {
						pos = i;
						return false; //found! break out of each()
					}
				} );
				if ( pos === -1 ) {
					/**
					 * not found, merge into global selection
					 */
					$.merge( $addToCartContainers, $newContainer );
				}
			}

			const $stateSelector  = $('[data-module="state-selector"]');
			if ( $stateSelector.length ) {
				/**
				 * there is supposed to be only one state selector module
				 */
				let selectedState = '';

				const $dropdownToggle = $stateSelector.find( '.dropdown-toggle' );
				if ( $dropdownToggle.length ) {
					selectedState = $dropdownToggle.text().trim();
				} else {
					const $stateSelect = $stateSelector.find( 'select' );
					selectedState = $stateSelect.length ? $stateSelect.val(): 'none';
				}

				isStateSelected = !['Select your State', 'none', ''].includes( selectedState );
			}

			/**
			 * iterate over the global selection of all known AddToCart buttons
			 */
			$addToCartContainers.each( ( i, el ) => {

				/**
				 * reindex all buttons by product code
				 */
				const $el = $( el );
				const productCode    = $el.data( 'product-code' ) ?? null;

				/**
				 * avoid multiple initialization
				 */
				if ( $el.data( 'is-initialized' ) ) {

					if ( i === 0 && !isPartnershipIdCookieUpdated ) {

						/**
						 * TODO all products on a partnership page will have the same partnershipid
						 * add a check to avoid repeatedly setting/deleting cookies
						 */
						const partnershipId = $el.data( 'partnership-id' );
						if ( partnershipId ) {
							setCookie( 'STYXKEY-partnershipid', partnershipId, 1 );
						} else {
							deleteCookie( 'STYXKEY-partnershipid' );
						}
						isPartnershipIdCookieUpdated = true;
					}

					/**
					 * If the button that has a payment plan toggle and an alternative product code, add it to index
					 */
					const altProductCode = $el.data( 'alt-product-code' ) ?? null;
					if ( altProductCode ) {
						/**
						 * make sure the alternative product code is included in the index
						 */
						if ( typeof containers[ altProductCode ] === 'undefined' ) {
							containers[ altProductCode ] = {
								/**
								 * There may be several buttons for the same product code.
								 * Will store jQuery objects.
								 */
								elements: [],
								enrollmentId: null
							};
						}

						/**
						 * See if the current button is already indexed (comparing by DOM nodes)
						 */
						let pos = - 1;
						$(containers[ altProductCode ].elements).each( ( i, el2 ) => {
							if ( $el[0] === el2[0] ) {
								pos = i;
								return false; //found, break out of each()
							}
						} );
						if ( pos === -1 ) {
							/**
							 * The current button was not found, add the jQuery wrapper to the index
							 */
							containers[ altProductCode ].elements.push( $el );
						}
					}
					/**
					 * avoid multiple initialization
					 */
					return true;
				}

				$el.data( 'is-initialized', 1 );

				if ( $el.parents( '.pattern-podcast-block-v4' ).length ) {
					/**
					 * change the caption on the button within this specific pattern *shrug*
					 */
					$el.find( '.add-to-cart button' ).text( 'Join Today' );
				}

				$el.data('status', Mode.unchecked);

				if ( typeof containers[ productCode ] === 'undefined' ) {
					/**
					 * This is the first time when we are seeing this product code -- add it to the index.
					 */
					containers[ productCode ] = {
						/**
						 * will store .add-to-cart-container jquery objects
						 * @note there might be more than one of them for a certain product code
						 */
						elements: [],
						enrollmentId: null
					};
				}

				/**
				 * If the current button is not yet indexed (comparing by DOM nodes) then do add it to the global index.
				 */
				let pos = - 1;
				$(containers[ productCode ].elements).each( ( i, el2 ) => {
					if ( $el[0] === el2[0] ) {
						pos = i;
						return false; //found, break out of each()
					}
				} );
				if ( pos === -1 ) {
					/**
					 * The current button was not found, add the jQuery wrapper to the index
					 */
					containers[ productCode ].elements.push( $el );
				}

				$el.bind( 'UPDATE_ADD_TO_CART_BUTTON', ( event, data ) => {
					if ( $el.prop('upsell' ) || $el.prop('is-checking-upsell') ){
						//throttling
						return;
					}

					$el.prop( 'is-checking-upsell', true );
					doStatusCheck( [ data.productCode ], afterStatusCheck );

					//containers[ data.productCode ].elements.push( data.$button );
				} );
			} );

			updateUserStatus();

			/**
			 * If some containers were passed as an argument, then we will only check the status of the first one.
			 * Otherwise, will check the status of ALL the AddToCart buttons that we have in the global index object.
			 */
			$newContainer = ( $newContainer && $newContainer.length ) ? $newContainer.first(): null;

			setTimeout( function() {
				doStatusCheck(
					$newContainer
						? [ $newContainer.data( 'alt-product-code' ) ?? $newContainer.data( 'product-code' ) ]
						: Object.keys( containers ),
					afterStatusCheck
				);
			}, 1 ); // this will run in a separate thread

		}

		function afterStatusCheck( response, checkedProductCodes ){
			if ( response === null || !isStateSelected ) {

				//disable all buttons
				$addToCartContainers.each( (i, container ) => {
					const $container = $(container);
					const $ctrl = $container.find( '.add-to-cart' );
					const label = isStateSelected ? 'Unavailable' : 'Select your State';
					const cssClass = isStateSelected ? 'is-invalid': 'is-invalid is-unknown-state';
					setMode( $container, Mode.unavailable );
					$ctrl.addClass( cssClass ).attr( 'title', label ).show().find( 'button' ).text( label );
					$ctrl.find( 'button' ).attr( 'disabled', isStateSelected );
				} );
				return;
			}

			/**
			 * update buttons for products that have some overrides
			 */
			// let invalidProducts = [];
			const updatedProducts = [];
			$( response ).each( ( i, r ) => {
				const props = r.Properties ?? {};

				if ( checkedProductCodes.indexOf(r.ProductCode) === -1 ){
					//continue -- we won't be updating the buttons of the products that were not checked
					return true;
				}

				updateProductButtons( r.ProductCode, {
					inMembership: ( props.InMembership ?? false ) === 'True',
					isEnrolled: ( props.IsEnrolled ?? false ) === 'True',
					inCart: ( props.InCart ?? false ) === 'True',
					isInvalid: ( props.Invalid ?? false ) === 'True',
					enrollmentId: r.EnrollmentId ?? null,
					seatsRemaining: props.SeatsRemaining ?? false,
					upsell: (typeof props['UpsellMembershipName'] !== 'undefined') ? {
						name: props['UpsellMembershipName'],
						productCode: props['UpsellMembershipProductCode'],
						monthlyPrice: props['UpsellMembershipMonthlyPrice'],
						months: props['UpsellMembershipMonths'],
					}: null
				} );
				updatedProducts.push( r.ProductCode );
			} );

			/**
			 * set the default active state for the remaining buttons
			 */
			$.each( Object.keys( containers ), ( i, productCode ) => {
				if ( updatedProducts.indexOf( productCode ) === - 1 && checkedProductCodes.indexOf( productCode ) !== -1 ){
					//continue -- we only update the buttons that are not yet updated and only of the products that were checked
					updateProductButtons( productCode, null );
				}
			} );

			$('body').trigger('ColibriEvent:AFTER_STATUS_CHECK', {
				'response': response,
				'add_to_cart_requested': add_to_cart_requested
			});
		}

		function updateUserStatus() {
			user.studentId = readCookie( 'STYXKEY-McKissock-UserId' );
			user.cartId = readCookie( 'STYXKEY-shoppingcartid' );
			user.role = readCookie( 'STYXKEY-McKissock-Role' );

			if ( user.studentId && user.role && 'Guest' !== user.role ) {
				user.isLoggedIn = true;
			} else if ( 'Guest' === user.role ) {
				user.isLoggedIn = 'Guest';
			} else {
				user.isLoggedIn = false;
			}
		}

		/**
		 * @param productCode
		 * @param productStatus
		 */
		function updateProductButtons( productCode, productStatus ) {

			if (  typeof containers[ productCode ] === 'undefined' ) {
				console.log('containers[ productCode ] is undefined ');
				return;
			}

			const $containers = containers[ productCode ].elements;
			containers[ productCode ].enrollmentId = productStatus ? productStatus.enrollmentId : null;

			$.each( $containers, ( i, $container ) => {

				if ( typeof $container.data('alt-product-code') !== 'undefined' && productCode !== $container.data('alt-product-code') ){
					return true; //skip --- do not update buttons that are not on the current product code
				}

				$container.data('product-status', productStatus );

				//this is wrong -- we are adding more listeners each time this function is called
				function handleEnroll(e) {

					const $contain = $(e.target).closest('.add-to-cart-container');
					const productStatus = $contain.data('product-status');
					const productCode = $contain.data('product-code');
					const $enrollButton = $contain.find('.enroll button')
					const paymentOptionId = $contain.data( 'payment-option-id' );
					const partnershipGroupItemId = $contain.data( 'partnership-group-item-id' ) ?? 0;

					/**
					 * To avoid repetitive activation -- disable immediately.
					 */
					$.each( containers[ productCode ].elements, ( i, $ctrl ) => {
						disable( $enrollButton );
						setMode( $ctrl, Mode.unavailable );
					});

					doEnroll( productCode, paymentOptionId, partnershipGroupItemId, productStatus ? productStatus.enrollmentId: null,
						(r) => {
							const elements = containers[productCode].elements;
							elements.push( $contain );
							$.each( elements, ( i, $ctrl ) => {
								//update all buttons that are related to the same product
								$ctrl.data('status', 'dashboard');
								hide( $ctrl.find( '.add-to-cart' ) );
								hide( $ctrl.find( '.enroll' ) );
								hide( $ctrl.find( '.checkout' ) );
								show( $ctrl.find( '.dashboard' ) );
								setMode( $ctrl, Mode.enrollable_done );
							} );
						}
					);

					e.preventDefault();
					e.stopPropagation();
					//return false;
				}

				function handleAddToCart(e) {
					$('body').trigger('ColibriEvent:START_HANDLE_ADD_TO_CART', e);

					const $target = $(e.target);
					const $contain = $target.closest('.add-to-cart-container');
					const isImmediateCheckout = (+$contain.data('immediate-checkout')) === 1;
					const productCode = $contain.data('alt-product-code') ?? $contain.data('product-code');
					const originalProductCode = $contain.data('product-code');
					const productStatus = $contain.data('product-status');
					const $addToCartButton = $contain.find('.add-to-cart button')
					const paymentOptionId = $contain.data('alt-payment-option-id') ?? $contain.data( 'payment-option-id' );
					const partnershipGroupItemId = $contain.data( 'partnership-group-item-id' ) ?? 0;
					const isUpsell = $contain.parent().parent().is('.membership-upgrade-container');
					const needDeclick = $addToCartButton.prop('declick');

					/**
					 * To avoid repetitive activation -- disable immediately.
					 */
					disable( $addToCartButton );
					$.each( containers[ originalProductCode ].elements, ( i, $ctrl ) => {
						setMode( $ctrl, Mode.unavailable );
					});

					doAddToCart( productCode, paymentOptionId, partnershipGroupItemId, productStatus ? productStatus.enrollmentId: null,
						(r) => {
							updateUserStatus();
							window.dispatchEvent( new CustomEvent( 'ColibriEvent:ADD_TO_CART_CALLBACK' ) );

							const elements = containers[originalProductCode].elements;
							elements.push( $contain );
							$.each( elements, ( i, $ctrl ) => {
								//update all buttons that are related to the same product
								if ( !needDeclick && !isImmediateCheckout ) {
									hide( $ctrl.find( '.add-to-cart' ) );
									hide( $ctrl.find( '.enroll' ) );
									hide( $ctrl.find( '.dashboard' ) );
									show( $ctrl.find( '.checkout' ) );
								}
								setMode( $ctrl, Mode.sellable_done );
							} );

							if ( isUpsell ){
								const $btn = $contain.parent().parent().siblings('.add-to-cart-container').find('.add-to-cart button');
								if ( ! $btn.parent().is(':disabled') && !$btn.is('.hidden')){
									$btn.prop('declick', 1).click();
									$btn.prop('disabled', false);
								}
							}

							if ( isImmediateCheckout ) {
								//maybe navigate away
								if( elements[ 0 ].find( '.checkout a' ).attr('triggered') !== 'yes' ){
									elements[ 0 ].find( '.checkout a' ).attr('triggered', 'yes');

									// if the Enroll/AddToCart btn in the upsell block was clicked
									if ( $target.closest('.upsell-block').length ) {
										$('body').bind('ColibriEvent:DO_ADD_TO_CART_SUCCESS', ( event, data ) => {
											$target.closest('.modal--quick-view').find('.product-actions .add-to-cart button ').trigger('click');
											window.location.href = window.colibri.cartUrl;
										});
									} else {
										window.location.href = window.colibri.cartUrl;
									}
								}
							}
						}
					);

					e.preventDefault();
					e.stopPropagation();
					//return false;
				}

				/**
				 * The presence of this element indicates that waitlist is allowed for this product.
				 */
				const $waitlist = $container.find( '.waitlist' );
				const $waitlistButton = $waitlist.find( 'button' );

				const $addToCart = $container.find( '.add-to-cart' );
				const $addToCartButton = $addToCart.find( 'button' );

				const $enroll = $container.find( '.enroll' );
				const $enrollButton = $enroll.find( 'button' );

				const $checkout = $container.find( '.checkout' );
				const $dashboard = $container.find( '.dashboard' );

				$addToCartButton.click( handleAddToCart );
				$enrollButton.click( handleEnroll );

				$('body').on('click', '.modal-body .add-to-cart button', handleAddToCart )
						 .on('click', '.modal-body .enroll button', handleEnroll );

				if ( productStatus && typeof productStatus.isInvalid !== 'undefined' && productStatus.isInvalid ) {
					// Do not enable CTA for invalid courses

					hide( $waitlist );
					hide( $dashboard );
					hide( $checkout );
					show( $addToCart );

					setMode( $container, Mode.unavailable );
					$addToCart.addClass( 'is-invalid' ).attr('title', 'Unavailable');
					$addToCartButton.text( isStateSelected ? 'Unavailable': 'Select your State' );
					if ( isStateSelected ) {
						$addToCartButton.attr( 'disabled', true )
					} else {
						$addToCart.addClass( 'is-unknown-state' );
					}
					if ( $container.prop( 'is-checking-upsell' ) ) {
						$container.prop( 'upsell', {} );
						$container.removeProp('is-checking-upsell');
					}
					return;
				}

				if ( $addToCartButton.text() === 'Unavailable' || $addToCartButton.text() === 'Select your State' ) {
					$addToCartButton.text( $addToCartButton.data( 'primary-label' ) ).parent().removeClass( 'is-invalid' ).removeClass( 'is-unknown-state' ).removeAttr( 'title' );
				}

				if ( productStatus?.upsell ) {
					$container.prop( 'upsell', productStatus.upsell ?? 'none' );
					$container.removeProp('is-checking-upsell');
				} else if ( $container.prop( 'is-checking-upsell' ) ) {
					$container.prop( 'upsell', {} );
					$container.removeProp('is-checking-upsell');
				}

				if ( productStatus && typeof productStatus.seatsRemaining !== 'undefined' && productStatus.seatsRemaining !== false ) {
					if ( productStatus.seatsRemaining > '0' ) {
						if ( $waitlist.length ) {
							//seats available && waitlist is allowed
							hide( $waitlist );
							disable( $waitlistButton );
						} else {
							//seats available and no waitlist
						}
						$addToCartButton.text( $addToCartButton.data( 'primary-label' ) );
						show( $addToCart );
						enable( $addToCartButton );

						setMode( $container, Mode.sellable_prompt );
					} else {
						if ( $waitlist.length ) {
							//no seats && waitlist is allowed
							$waitlistButton.text( 'Add to Waitlist' );
							show( $waitlist );
							enable( $waitlistButton );
							hide( $addToCart );
							disable( $addToCartButton );

							setMode( $container, Mode.waitable_prompt );
						} else {
							//no seats and waitlist not allowed
							$waitlistButton.text( 'Sold Out' );
							$addToCartButton.text( 'Sold Out' );
							$addToCartButton.addClass( 'sold-out' );
							disable( $addToCartButton );
							setMode( $container, Mode.waitable_disabled );
							//there is no way it could be enabled again, so exit already
							return;
						}
					}

					if ( $waitlist.length && ! $waitlist.hasClass( 'hidden' ) ){
						return;
					}
				}

				if ( ( user.isLoggedIn === false && user.role !== 'Guest' ) || ( productStatus === null ) ) {

					if ( productStatus && productStatus.inCart ) {
						/**
						 * This addresses the special case covered here:
						 * @see https://colibrigroup.atlassian.net/browse/PS-13911
						 */
						disable( $enrollButton );
						hide( $enroll );
						hide( $addToCart );
						show( $checkout );
						hide( $dashboard );
						setMode( $container, Mode.sellable_done );
						return;
					}

					enable( $addToCartButton );
					show( $addToCart );
					disable( $enrollButton );
					hide( $enroll );
					hide( $checkout );
					hide( $dashboard );
					setMode( $container, Mode.sellable_prompt );

					return;
				}

				if ( user.isLoggedIn && productStatus.inMembership && 'Student' === user.role ) {
					// show zero price for visitors who have membership
					const $containerCard = $container.closest( '.card' );
					updatePriceElements( $containerCard );
					$containerCard.attr( 'data-memb', true );
				}

				if ( productStatus.inMembership && !productStatus.isEnrolled && !productStatus.inCart ) {

					enable( $enrollButton );
					show( $enroll );
					hide( $addToCart );
					hide( $checkout );
					hide( $dashboard );

					setMode( $container, Mode.enrollable_prompt );
					return;
				}

				if ( productStatus.isEnrolled ) {

					hide( $enroll );
					hide( $addToCart );
					hide( $checkout );
					show( $dashboard );

					setMode( $container, Mode.enrollable_done );
					return;
				}

				if ( productStatus.inCart ) {

					disable( $enrollButton );
					hide( $enroll );
					hide( $addToCart );
					show( $checkout );
					hide( $dashboard );

					setMode( $container, Mode.sellable_done );
					return;
				}

				enable( $addToCartButton );
				show( $addToCart );
				hide( $enroll );
				hide( $checkout );
				hide( $dashboard );

				setMode( $container, Mode.sellable_prompt );
			} );

		}

		function updatePriceElements($container) {
			$container.find('.regular-price').text('$0.00');
			$container.find('.pricing-container').addClass('is-member');
			$container.find('.has-discount').removeClass('has-discount');
			$container.find('.has-special-price').removeClass('has-special-price');
		}

		/**
		 * Watch for modal load and set price to 0.00$ for members
		 * */
		$('body').on('ColibriEvent:QUICK_VIEW_READY', ( event, data ) => {
			if ( data?.productCode ) {
				const $card = $('[data-product-code="'+data.productCode+'"]');
				const inMembership = $card.data('memb');

				if ( user.isLoggedIn && inMembership && 'Student' === user.role ) {
					const $modal = $('.modal--quick-view');

					setTimeout(function () {
						updatePriceElements($modal);
					},1);
				}
			}
		});


		/**
		 * @param productCodes
		 * @param callback
		 */
		function doStatusCheck( productCodes, callback ) {

			if ( !productCodes || (Array.isArray(productCodes) && !productCodes.length)){
				//do not check if product codes are unknown
				return;
			}

			let url = settings.apiPrefix + '/productSearch/ProductProperties?subsidiaryId=' + settings.subsidiaryId;

			url += ( user.studentId !== null )
					 ? '&studentId=' + user.studentId
					 : '';
			url += user.cartId
					 ? '&shoppingCartID=' + user.cartId
					 : '';

			const args = {
				...settings.ajax,
				url,
				data: '{\"products\":' + JSON.stringify( productCodes ) + '}',
			};

			$.ajax( args ).done( ( response, error ) => {
				callback(
					JSON.stringify( response ) !== '[]'
					? response
					: [],
					productCodes
				);
			} ).fail((error, b) => {
				callback( null, productCodes );
			});
		}

		/**
		 *
		 * @param searchResultId
		 * @param paymentOptionId
		 * @param partnershipGroupItemId
		 * @param enrollmentId
		 * @param callback
		 */
		function doAddToCart( searchResultId, paymentOptionId, partnershipGroupItemId, enrollmentId, callback ) {

			if ( add_to_cart_requested.indexOf( searchResultId ) !== -1 ){
				/**
				 * avoid duplicate additions
				 */
				return;
			}

			add_to_cart_requested.push( searchResultId );

			let url = settings.apiPrefix + '/cart/items.json?searchResultId=' + searchResultId;

			url += enrollmentId
					 ? '&enrollmentId=' + enrollmentId
					 : '';
			url += paymentOptionId
					 ? '&paymentOptionId=' + paymentOptionId
					 : '';
			url += partnershipGroupItemId
				? '&PartnershipGroupItemId=' + partnershipGroupItemId
				: '';

			pushAnalyticsData( searchResultId, 'add_to_cart' );

			$.ajax( {
				...settings.ajax,
				url,
				xhrFields: {
					withCredentials: true,
				},
				success( cart, response ) {
					$('body').trigger('ColibriEvent:DO_ADD_TO_CART_SUCCESS', [cart]);

					/*
					Returns an array containing items of this form:

					Id: 22724623
					ShoppingCartID: 6693664
					SubsidiaryID: 22
					CourseID: 23547
					CartItemAmount: 0
					StateAbbv: "AL"
					LicenseTypeID: 44
					LicenseTypeName: "Nursing"
					StudentID: 14658062
					cartItemDate: "/Date(1587409313846-0500)/"
					XACTN_TS: "/Date(1587409313846-0500)/"
					Gift: false
					AddedFrom: "ref:https://dev.westernschools.com/nursing/alabama/"
					Upsell: false
					url: ""
					Invalid: false
					AdditionalCertificate: false
					*/

					callback( response );
				},
				// error( xhr, code, error ) {},
			} );
		}

		/**
		 * @param {string} productCode
		 * @param {int} paymentOptionId
		 * @param {int|null} partnershipGroupItemId
		 * @param {*} enrollmentId
		 * @param {function} callback
		 */
		function doEnroll( productCode, paymentOptionId, partnershipGroupItemId, enrollmentId, callback ) {

			if ( enrollment_requested.indexOf( productCode ) !== -1 ){
				/**
				 * avoid duplicate additions
				 */
				return;
			}

			enrollment_requested.push( productCode );

			let url = settings.apiPrefix + '/my/enroll.json?searchResultId=' + productCode;
			url += enrollmentId
					 ? '&enrollmentId=' + enrollmentId
					 : '';

			url += paymentOptionId
					 ? '&paymentOptionId=' + paymentOptionId
					 : '';
			url += partnershipGroupItemId
				? '&partnershipGroupItemId=' + partnershipGroupItemId
				: '';

			pushAnalyticsData( productCode, 'add_to_cart' );

			$.ajax( {
				...settings.ajax,
				url,
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'text json',
				success: function( xhr, cart ) {
					$('body').trigger('ColibriEvent:DO_ENROLL_SUCCESS', [cart]);
					callback( cart );
				},
				// error( xhr, code, error ) {
				// 	if ( xhr.status === 401 ) {}
				// },
			} );
		}

		/**
		 * @param {string} name
		 * @return {string|null}
		 * @description Read Cookie by name
		 */
		function readCookie( name ) {
			const nameEQ = name + '=';
			const ca = document.cookie.split( ';' );
			for ( let i = 0; i < ca.length; i ++ ) {
				let c = ca[ i ];
				while ( c.charAt( 0 ) === ' ' ) {
					c = c.substring( 1, c.length );
				}
				if ( c.indexOf( nameEQ ) === 0 ) {
					return c.substring( nameEQ.length, c.length );
				}
			}
			return null;
		}

		function setCookie(name,value,days) {
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days*24*60*60*1000));
				expires = "; expires=" + date.toUTCString();
			}

			var temp = location.host;
				temp = temp ? temp.split('.'): '';
				temp = temp ? temp.reverse(): '';
				 temp = temp ? '.' + temp[1] + '.' + temp[0] : '';

			const domain = temp ? '; domain=' + temp: '';

			document.cookie = name + "=" + (value || "")  + expires + domain + "; path=/";
		}

		function deleteCookie(name){
			document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		}

		function show( $el ) {
			$el.removeClass( 'hidden' );
		}

		function hide( $el ) {
			$el.addClass( 'hidden' );
		}

		function disable( $el ) {
			$el.attr( 'disabled', true );
		}

		function enable( $el ) {
			$el.removeAttr( 'disabled' );
		}

		function setMode( $ctrl, mode ){
			if ( typeof Mode[ mode ] === 'undefined' ) {
				console.error( 'unknown add to cart button mode', mode );
			}
			/**
			 * do not merge the following into one, because .quick-view is nested inside .card
			 */
			$ctrl.closest('.quick-view').attr( 'data-product-status', mode );
			$ctrl.closest('.card').attr( 'data-product-status', mode );
		}

		// Capture cart cookies on partnership group pages
		if ($('body').hasClass('retail-group-template') || $('body').hasClass('university-group-template')) {
			$('body').one('ColibriEvent:DO_ADD_TO_CART_SUCCESS', function (event) {

				// One dozen shopping cart cookies, boxed.
				const cookieNames = [
					"McKissock-LongExpiration",
					"McKissock-Role",
					"McKissock-Token",
					"McKissock-UserId",
					"shoppingcartid",
					"STYXKEY-McKissock-LongExpiration",
					"STYXKEY-McKissock-Role",
					"STYXKEY-McKissock-Token",
					"STYXKEY-McKissock-UserId",
					"STYXKEY-partnershipid",
					"STYXKEY-shoppingcartid",
					"X-Credential"
				];

				// Get those cookies and dump the values. If they don't exist, say so.
				cookieNames.forEach((item, index) => {
					const cookieValue = readCookie(item);
					if (cookieValue) {
						console.log(item, ": ", cookieValue);
					} else {
						console.log(item, ": Not Set");
					}
				});
			})
		}
	});
}( jQuery ) );
